import { RENTAL_PORTAL_LISTING_STATUSES } from '../../../../../../constants/rentalPortal'
import { EntityStatus } from '../../../../../Entity'

import * as styles from './ListingProfileHeaderStatusSelectOption.module.css'

function ListingProfileHeaderStatusSelectOption({ value }) {
  return (
    <EntityStatus
      className={styles.ListingProfileHeaderStatusSelectOption}
      id={value?.value}
      statuses={RENTAL_PORTAL_LISTING_STATUSES}
    />
  )
}

export default ListingProfileHeaderStatusSelectOption
